import { isNonEmptyString } from '@thesavingsgroup/utils/isNonEmptyString';
import { stripNonNumericCharacters } from '@thesavingsgroup/utils/stripNonNumericCharacters';

export const toNumberString = (
  numericValue?: string | number | null,
): string => {
  const valueAsString = stripNonNumericCharacters(numericValue);

  return isNonEmptyString(valueAsString)
    ? Number(valueAsString).toLocaleString()
    : '';
};
